module.exports = __webpack_public_path__ + "img/addbtn.2e0b2b7e.png";